import countdown, { type CountdownOptions } from "@client/lib/jquery/countdown";
import { makeWith, makeWrap } from "./factory";

export interface CountdownProps {
  countdownOptions: CountdownOptions;
}

export const withCountdown = makeWith<CountdownProps>(
  (element: HTMLElement, props: CountdownProps) => countdown(element, props.countdownOptions),
  "countdownOptions"
);

const countdownTag = makeWrap<CountdownProps>(withCountdown);

export const CountdownDiv = countdownTag<HTMLDivElement>("div");

export default countdownTag;
